<template>
  <li class="cart-nav onhover-dropdown">
    <div class="cart-box" v-if="is_manual_path !== 'manual' && is_manual_path !== 'ackage'">
      <router-link :to="'/cart'" >
      <vue-feather type="shopping-cart"   ></vue-feather>
      <span class="badge rounded-pill badge-success">{{cart_store.cart.length+cart_store.cart_vdo.length}}</span></router-link>
    </div>
    <div class="cart-box" v-if="is_manual_path === 'manual'">
      <router-link :to="'/cart-manual'" >Manual
      <vue-feather type="shopping-cart" stroke="none" fill="green"></vue-feather>
      <span class="badge rounded-pill badge-success">{{cart_store_manual.cart.length}}</span></router-link>
    </div>
    <div class="cart-box" v-if="is_manual_path === 'ackage'">
      <router-link :to="'/cart-package'" > Package
      <vue-feather type="shopping-cart" stroke="none" fill="green"></vue-feather>
      <span class="badge rounded-pill badge-success">{{cart_store_package.cart.length}}</span></router-link>
    </div>
  </li>
</template>

<script setup>

import { useCartStore } from "./../../store/modules/cart";
import { useCartStoreManual } from "./../../store/modules/cart_manual";
import { useCartStorePackage } from "./../../store/modules/cart_package";
import { useRoute } from 'vue-router'

const cart_store = useCartStore()
const cart_store_manual = useCartStoreManual()
const cart_store_package = useCartStorePackage()

const route = useRoute()
//console.log("route.query",route.path)
let is_manual_path = route.path

is_manual_path = is_manual_path.substring(is_manual_path.length-6,is_manual_path.length)
//console.log("route.queryroute.path:"+is_manual_path)


</script>
